import React, { useEffect } from "react";
import Slider from "react-slick";
import flag from "../assets/img/tarh-parcham-iran-psdtarh.png";
import logo from "../assets/img/logo-black2.png";
import logo2 from "../assets/img/logo-black.png";
import slide1 from "../assets/img/slider1.png";
import slide2 from "../assets/img/slider2.png";
import { storageApi } from "../storage/storageApi";
import { appRoutes, useAppNavigation } from "../router/routes";

const settings = {
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 1000,
  autoplaySpeed: 5000,
  // cssEase: "linear",
  arrows: false,
};

const AuthLayout = ({ children }) => {
  const isUserLogin = storageApi.useIsUserLogin();
  const { isUserForceUpdateProfile } = storageApi.useGetUser();
  const { navigate } = useAppNavigation();
  const handleUrl = (target) => {
    console.log(target);
  };
  useEffect(() => {
    if (isUserLogin && !isUserForceUpdateProfile) {
      navigate(appRoutes.dashboard);
    }
  }, [isUserLogin, isUserForceUpdateProfile]);

  return (
    <div className="relative w-screen h-screen flex flex-col md:flex-col  justify-center items-center bg-gray-100">
      <div className=" bg-slate-200 py-2 px-4 rounded w-13/24 visible md:hidden">
        <button
          href
          onClick={() =>
            window.open("https://files.defadoc.ir/sadem_guide.pdf")
          }
          className={"bg-white text-black p-2 text-[12px] mx-1 rounded-xl"}
        >
          راهنما
        </button>

        <button
          onClick={() => window.open("tel:02188548076", "_blank")}
          className={"bg-white text-black p-2 text-[12px] mx-1 rounded-xl"}
        >
          02188548076
        </button>
      </div>
      <div className="md:w-[80%] w-[90%] md:h-[85%] h-auto bg-white rounded-xl  shadow-lg overflow-y-scroll mt-4">
        <div className="grid md:grid-cols-2 grid-cols-1 gap-0 h-full w-full">
          <div className="relative">
            <div className="absolute top-0 right-0">
              <img src={flag} className=" md:w-52 w-24" />
            </div>
            <div className="flex gap-8 h-full w-full px-6 flex-col">
              <div>
                <div className="flex flex-col items-center gap-2">
                  <div className="h-32 w-32 flex justify-center items-center">
                    <img src={logo} />
                    <img src={logo2} />
                  </div>
                  {/*<p className="md:text-sm text-xs text-center text-gray-500">*/}
                  {/*  ستاد مرکزی گرامیداشت مناسبت های ملی دفاع مقدس و مقاومت*/}
                  {/*</p>*/}
                  <p className="text-center md:text-md text-sm md:leading-8 leading-6">
                    ورود به سامانه سادم از طریق رمز یکبار مصرف
                  </p>
                </div>
              </div>
              <div className="w-full flex flex-col items-center h-full">
                {children}
              </div>
            </div>
          </div>
          <div className="auth-slider-bg rounded-tl-xl rounded-bl-xl  md:mt-0 mt-8 md:flex hidden flex-col justify-center items-center relative">
            <div className=" md:w-[80%] w-[90%] mx-auto h-auto text-white items-center slider-style">
              <div className={"absolute top-4 right-4 "}>
                <button
                  onClick={() =>
                    window.open("https://files.defadoc.ir/sadem_guide.pdf")
                  }
                  className={
                    "bg-white text-black p-2 text-[12px] mx-1 rounded-xl"
                  }
                >
                  راهنما
                </button>
                <button
                  onClick={() => window.open("tel:02188548076", "_blank")}
                  className={
                    "bg-white text-black p-2 text-[12px] mx-1 rounded-xl"
                  }
                >
                  02188548076
                </button>
              </div>
              <Slider {...settings}>
                <div className=" mb-8">
                  <div className="flex flex-col gap-4">
                    <img src={slide1} className="max-w-[400px] self-center" />
                    <p className=" text-center">
                      ثبت برنامه ها و فعالیت های مرتبط با حوزه دفاع مقدس و
                      مقاومت
                    </p>
                  </div>
                </div>
                <div className=" mb-8">
                  <div className="flex flex-col gap-4">
                    <img src={slide2} className="max-w-[400px] self-center" />
                    <p className=" text-center">
                      ثبت برنامه ها و فعالیت های مرتبط با حوزه دفاع مقدس و
                      مقاومت
                    </p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
